export const trackingPlanEnum = {
  free: {
    key: "_free",
    value: "FREE",
  },
  basic: {
    key: "_basic",
    value: "BASIC",
  },
  essential: {
    key: "_essential",
    value: "ESSENTIAL",
  },
  plus: {
    key: "_plus",
    value: "PLUS",
  },
  starter: {
    key: "_starter",
    value: "STARTER",
  },
  advanced: {
    key: "_advanced",
    value: "ADVANCED",
  },
  enterprise: {
    key: "_enterprise",
    value: "ENTERPRISE",
  },
  proLite: {
    key: "_pro_lite",
    value: "PRO LITE",
  },
  pro2: {
    key: "_pro2",
    value: "PRO2",
  },
  pro: {
    key: "_pro",
    value: "PRO",
  },
  unknown: {
    key: "unknown",
    value: "UNKNOWN",
  },
};
